/* Recherche et filtres de l'annuaire « Find your city ».

   Aucun rendu n'est fait ici : tous les comptes sont deja dans le HTML servi
   par Liquid. Ce fichier ne fait que masquer/afficher. Sans JavaScript, la
   page reste complete et tous les liens fonctionnent : seuls le champ de
   recherche et les pastilles deviennent inertes, et ils ne sont rendus que
   si le marchand les a actives. */
(() => {
  const init = (root) => {
    if (root.dataset.cityDirectoryReady === 'true') return;
    root.dataset.cityDirectoryReady = 'true';

    const search = root.querySelector('[data-city-search]');
    const chips = Array.from(root.querySelectorAll('[data-city-filter]'));
    const countries = Array.from(root.querySelectorAll('[data-city-country]'));
    const counter = root.querySelector('[data-city-count]');
    const empty = root.querySelector('[data-city-empty]');
    const singular = (counter && counter.dataset.labelOne) || '[count] account';
    const plural = (counter && counter.dataset.labelOther) || '[count] accounts';

    let game = 'all';

    const apply = () => {
      const query = search ? search.value.trim().toLowerCase() : '';
      let visible = 0;

      countries.forEach((country) => {
        const haystack = country.dataset.cityCountry || '';
        const countryMatches = query !== '' && haystack.includes(query);
        let shown = 0;

        country.querySelectorAll('[data-city-account]').forEach((account) => {
          const text = account.dataset.cityAccount || '';
          const matchesText = query === '' || countryMatches || text.includes(query);
          const matchesGame = game === 'all' || account.dataset.cityGame === game;
          const match = matchesText && matchesGame;
          account.hidden = !match;
          if (match) shown += 1;
        });

        country.hidden = shown === 0;
        visible += shown;
      });

      if (counter) {
        const template = visible === 1 ? singular : plural;
        counter.textContent = template.replace('[count]', String(visible));
      }
      if (empty) empty.hidden = visible !== 0;
    };

    if (search) {
      search.addEventListener('input', apply);
      // Le navigateur restaure la valeur saisie au retour arriere : on
      // reapplique une fois pour que l'affichage colle au champ.
      if (search.value) apply();
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        game = chip.dataset.cityFilter;
        chips.forEach((other) => other.setAttribute('aria-pressed', String(other === chip)));
        apply();
      });
    });

    if (!search && chips.length === 0) return;
    apply();
  };

  const boot = () => document.querySelectorAll('[data-city-directory]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // L'editeur de theme recharge une section sans recharger la page.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-city-directory]').forEach(init);
  });
})();
